@if (SuppliedQueryData) {
  <div class="container-fluid h-100 d-flex flex-column">
    <div class="row">
      <div class="col">
        <h2>Files</h2>
      </div>
    </div>
    <div class="row">
      <div class="col"></div>
      <div class="col-auto">
        <button class="btn btn-primary" (click)="uploadFile()">
          Upload file
        </button>
      </div>
    </div>
    <div class="row row-padding flex-grow-1">
      <div class="col">
        <app-site-files-grid
          [gridName]="'SiteFiles'"
          [ColumnIdToColumnActions]="ColumnIdToColumnActions"
          [suppliedQueryData]="SuppliedQueryData"
          [(reloadGridData)]="reloadSiteFileGridData"
          [preventDistinctCount]="true"
          (actionEvent)="action($event)"
        ></app-site-files-grid>
      </div>
    </div>
  </div>
}
